#!/usr/bin/env node

import { Command } from 'commander';
import chalk from 'chalk';
import { generateSplash, removeSplash, generateFlavorSplashes } from '../index.js';

const program = new Command();

program
  .name('react-native-splash')
  .description('React Native Splash Screen Generator')
  .version('1.0.0');

program
  .command('generate')
  .description('Generate splash screen assets')
  .option('-c, --config <path>', 'Path to config file')
  .option('-f, --flavor <name>', 'Generate splash screen for specific flavor')
  .action(async options => {
    try {
      await generateSplash(options.config, options.flavor);
      console.log(chalk.green('✓ Splash screen generation completed successfully!'));
    } catch (error) {
      console.error(chalk.red('✗ Error generating splash screen:'), error);
      process.exit(1);
    }
  });

program
  .command('remove')
  .description('Remove splash screen assets')
  .option('-f, --flavor <name>', 'Remove splash screen for specific flavor')
  .action(async options => {
    try {
      await removeSplash(options.flavor);
      console.log(chalk.green('✓ Splash screen removed successfully!'));
    } catch (error) {
      console.error(chalk.red('✗ Error removing splash screen:'), error);
      process.exit(1);
    }
  });

program
  .command('generate-flavors')
  .description('Generate splash screens for all flavors')
  .action(async () => {
    try {
      await generateFlavorSplashes();
      console.log(chalk.green('✓ All flavor splash screens generated successfully!'));
    } catch (error) {
      console.error(chalk.red('✗ Error generating flavor splash screens:'), error);
      process.exit(1);
    }
  });

program.parse(process.argv);
